<template>
<h2 class="heading">ISS Meeting Report Details</h2>
    <div class="detail" style="width:100%">
        <table style="width:95%">
            <tr><th>Company Name</th> 
                <td width="400">{{meetingReport.companyName}}</td>
                <th>Ticker</th> 
                <td><b>{{meetingReport.ticker}}</b><span v-if="meetingReport.ashare.name"> - {{meetingReport.ashare.name}}</span></td>
                <th>ISIN</th>
                <td>{{meetingReport.isin}}</td>
            </tr>
            <tr>
                <th>Sector</th> 
                <td>{{meetingReport.industrySector}}</td>
                <th>Main Business</th> 
                <td colspan="3">{{meetingReport.ashare.mainBusiness}}</td>
            </tr>
            <tr>
                <th>Meeting Date</th> 
                <td>{{meetingReport.meetingDate}}</td>
                <th>Record Date</th> 
                <td>{{meetingReport.recordDate}}</td>
                <th>Ballot Cutoff Date</th>
                <td>{{meetingReport.ballotCutoffDate}}</td>
            </tr>
            <tr>
                <th>Location</th> 
                <td>{{meetingReport.locationName}}</td>
                <th>Meeting Type</th> 
                <td>{{meetingReport.meetingType}}</td>
                <th>Country</th>
                <td>{{meetingReport.country}}</td>
            </tr>
            <tr>
                <th>Metting Status</th> 
                <td>{{meetingReport.meetingStatus}}</td>
                <th>Ballot Status</th> 
                <td>{{meetingReport.ballotStatus}}</td>
                <th>Votable Shares</th> 
                <td>{{global.number_format(meetingReport.votableShares)}}</td>
            </tr>
            <tr>
                <td colspan="6">
                    <el-table :data="meetingReport.meetingReportDetails" height="520" style="width:98%; margin:15px auto;">
                        <el-table-column prop="proposalNo" label="No" align="center" width="50" />
                        <el-table-column prop="proposalCode" label="Code" align="center" />
                        <el-table-column prop="proposalText" label="Proposal / Agenda" align="left"  width="400"/>
                        <el-table-column prop="votable" label="Votable" align="center" />
                        <el-table-column prop="mgmtRecommendation" label="Mgmt Recommendation" align="center" />
                        <el-table-column prop="issRecommendation" label="ISS Recommendation" align="center" />
                        <el-table-column prop="voted" label="voted" align="center" />
                        <el-table-column prop="votedAgainstMgmt" label="votedAgainstMgmt" align="center" />
                        <el-table-column prop="votedAgainstMgmt" label="votedAgainstMgmt" align="center" />
                        <el-table-column prop="meetingId" label="Action" align="center" width="375" style="padding-right:15px;" >
                            <a href="https://secure.issgovernance.com/AuthApp/" target="_blank">Vote</a>
                        </el-table-column>
                    </el-table>
                </td>
            </tr>
        </table>

        <div v-if="errMsg != ''" style="width:1024px;margin-top:15px;"><el-alert :title="errMsg" type="error" /></div>
        <div style="text-align:center; margin-top:15px; width:95%">
            <el-button @click="$router.push('/iss/topHoldingBallots')">Back to list</el-button>
        </div>
    </div>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Document, Search, Delete, Edit } from '@element-plus/icons-vue'

export default {
    components: {
        Document
    },
    data() {
        return {
            meetingReport: {
                ashare: {},
                meetingReportDetails: []
            },
            errMsg: '',
            global,
        }
    },
    async mounted() {
        this.global.index = "iss";
        this.currentUser = this.global.currentUser;
        let meetingId = this.$route.query.meetingId;
        let ballotId = this.$route.query.ballotId;
        let result = await AXIOS("/iss/getMeetingReportDetail", {meetingId: meetingId, ballotId: ballotId});
        console.log(result);
        if (result.success) {
            this.meetingReport = result.data;
        } else {
            this.errMsg = result.errMsg;
        }
    },
    methods: {
        
    }
}
</script>

<style>
    .label {padding-left:20px;}
</style>